import {ReactElement} from 'react';
import {useTheme} from 'styled-components';
import {useMobile} from '@/lib/hooks/useMobile';

import {StyledPatterns} from './FeatureCardPatterns.styles';
import {isZsl} from "@lib/utils";

type FeatureCardPaternsProps = {
  backgroundColour: string;
};

// Component
export default function FeatureCardPatterns(props: FeatureCardPaternsProps): ReactElement<any> {
  const isMobile = useMobile();
  const { key } = useTheme();

  const src = `/FeatureCardPatterns/${key}/${props.backgroundColour === 'yellow' ? 'PatternFeature' : 'Pattern'}.svg`;
  return (
    !isZsl(key) ?
    <StyledPatterns>
      {!isMobile && <img loading="lazy" alt="" className="pattern left" src={src} />}
      <img loading="lazy" alt="" className="pattern right" src={src} />
    </StyledPatterns>
    :
    <></>
  );
}
